<template>
  <div>
    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
      <el-checkbox v-for="item in dataList" :label="item.name" :key="item.id">{{item.name}}</el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { ExportCheckController, DictionaryController,ExportSetController } from '@/api';

export default {
  name: 'ExportSet',
  prop: {
    businessKey: {
      type: String,
      default: undefined
    }
  },
  data () {
    return {
      checkAll: false,
      checkedCities: [],
      dataList: [],
      isIndeterminate: true,
      businessKeyTemp: this.businessKey
    };
  },
  mounted () {
    this.initData()
  },
  methods: {
    handleCheckAllChange (val) {
      // this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.dataList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.dataList.length;
    },
    initData (businessKey) {
      alert(businessKey)
      let filter = {
        businessKey: businessKey
      }
      ExportSetController.listDict(this, filter).then(res => {
        this.dataList = res.data
      })
    }
  },
  watch: {
    businessKey: {
      handler: function (newValue, oldValue) {
        this.initData(newValue)
      }
    }
  }
}
</script>

<style scoped>

</style>
